import clsx from "clsx";
import { HTMLAttributes, useContext } from "react";

import { ButtonContext } from "../context";

import styles from "./button-icon.module.css";

type Props = HTMLAttributes<HTMLDivElement>;

const ButtonIcon = (props: Props) => {
    const { className, ...otherProps } = props;

    const { size, variant } = useContext(ButtonContext);

    return (
        <div className={clsx(styles.button_icon, className)} data-variant={variant} data-size={size} {...otherProps} />
    );
};

export { ButtonIcon };
export type { Props as ButtonIconProps };
